import $ from 'jquery';
import {UiWidget} from "./abstract";

/**
 * @example data-init-toggle-class='[{"target":"#navigation", "class": "nav-main--active"},{"target":"body", "class": "nav-main--active"}]'
 */
export class ToggleClassWidget extends UiWidget{

	/**
	 *
	 * @param selector
	 */
	constructor(selector){
		super(selector);
	}

	/**
	 *
	 */
	bindEventListeners(): void{
		this.elements.on('click', (e: any) => {
			this.handleClickEvent(e);
		});
	}

	/**
	 *
	 * @param {Event} e
	 */
	handleClickEvent(e: Event){
		let eventTarget: EventTarget = e.currentTarget;

		// inline attribute options
		let options: ToggleClassWidgetOptions|Array<ToggleClassWidgetOptions> = JSON.parse((eventTarget as HTMLElement).dataset.initToggleClass);

		if(Array.isArray(options)){
			for(let item of options){
				$(item.target).toggleClass(item.class)
			}
		}else{
			$(options.target).toggleClass(options.class)
		}
	}
}

interface ToggleClassWidgetOptions {
	/**
	 * self|parent|child or selector
	 */
	target: string;

	/**
	 * css class
	 */
	class: string;
}


// WEBPACK FOOTER //
// ./src/js/widgets/toggle-class.tsx